<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-store-alt page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4">
							<div class="row g-2">
								<div class="col d-none d-lg-block" style="width:380px;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'company_group_id',
												title: 'Cég csoport',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...company_groups.data ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden cégcsoport ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-city"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>c-Store Telephelyek / raktárak</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Store</li>
							<li class="breadcrumb-item active">Lista</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'store',
						params: {
							row_height: 48,
							row_class: (row) => {
								if (row.sandbox) return 'bg-body-secondary text-dim'
								return ''
							},
							render_footer (list) {
								let total = 0
								for (let store of list.data) {
									total += store.licence_fee
									total -= store.partner_dividend
								}
								return `Összes éves díj: <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(total).format('0,0')} Ft</strong>`
							},
							columns: [
								{
									title: 'Adatbázis',
									field: 'company_db_name',
									type: 'string',
									type: {
										render (value, row, options) {
											if (value !== null) {
												const open_btn = `<a href="https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_${value}" target="_blank" class="btn btn-dark text-light p-2 float-start"><i class="fa fa-fw fa-server"></i></a>`
												const ntak_log_btn = (row.ntak_errors > 0) ? `<a href="/c_order/error_log/ntak_error_list?db_name=${value}" class="btn btn-dark text-warning p-2" style="width:55px;"><small>${row.ntak_errors}</small><i class="fa fa-fw fa-exclamation-triangle"></i></a>`
												: '<button class="btn btn-dark text-dim disabled p-2" style="width:55px;"><i class="fa fa-fw fa-exclamation-triangle"></i></button>'

												return `<div class="btn-group me-2">${open_btn}${ntak_log_btn}</div> ${value}`
											} else {
												return ''
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 180
								},
								{
									title: 'Cég',
									field: 'company_name',
									value: (v, row) => `${row.company_name} ${row.company_tax_number}`,
									type: {
										render (value, row, options) {
											if (row.company_id === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `<div class="list-db-id">${row.company_id}</div> ${row.company_name}<br /><small class="text-dim">${row.company_tax_number}</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 230
								},
								{
									title: 'Csoport',
									field: 'company_group_id',
									type: {
										render (value, row, options) {
											if (value === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `<img src="assets/groups/${value}.png" />`
										}
									},
									options: {
										class: 'text-center'
									},
									width: 70
								},
								{
									title: 'Telephely',
									field: 'site_name',
									value: (v, row) => `${row.site_name} ${row.site_area_code || ''} ${row.site_city || ''} ${row.site_address || ''}`,
									type: {
										render (value, row, options) {
											return `
												<div class="list-db-id">
													<button class="btn btn-sm btn-dark px-2 py-0" onclick="Anvil.page.openSite('${row.company_db_id}', '${row.site_id}')">${row.site_id}</button><br />
													${row.site_geo_coords ? '<small class="text-dim"><i class="fa fa-map-marker-alt me-2"></i></small>' : '<small class="text-warning"><i class="fa fa-map-marker-alt me-2" style="transform:rotate(30deg);"></i></small>'}
												</div>
												<i class="fa fa-sm fa-${Anvil.models.c_order.Site.Types.find(t => t.value == row.site_type).icon} me-1"></i>${row.site_name}<br />
												<small class="text-dim">${row.site_area_code || ''} ${row.site_city || ''}` + (row.site_address ? `, ${row.site_address}` : '') + `</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 270
								},
								/*
								{
									title: 'Raktár',
									field: 'storage_name',
									type: {
										render (value, row, options) {
											return `<div class="list-db-id">${row.storage_id}</div> ${row.storage_name}`
										}
									},
									options: {
										cutoff: 60
									},
									width: 240
								},
								*/
								{
									title: 'Név / Raktár',
									field: 'storage_name',
									value: (v, row) => {
										return `${row.device_info.hostname} ${row.storage_name}`
									},
									type: {
										render (value, row, options) {
											const online = Anvil.moment(row.now).subtract(2, 'minutes').isBefore(Anvil.moment(row.last_report_dt))
											const dt = Anvil.moment(row.recent_start)
											const color = (dt.isBefore(Anvil.moment().subtract(1, 'month'))) ? 'text-danger' :
														(dt.isBefore(Anvil.moment().subtract(1, 'week'))) ? 'text-warning' : 'text-blue'
											return `<div class="list-db-id">
														<i class="fa fa-desktop ${color}"></i><br /><small class="text-dim">${row.storage_id}</small>
													</div>
													${online ? `<div class="float-end ms-2"><span class="material-icons-outlined text-success">router</span></div>` : ''}
													<strong class="${color}">${row.device_info.hostname}</strong><br />
													<small class="text-dim">${row.storage_name}</small>`
										}
									},
									options: {
										cutoff: 40
									},
									width: 270
								},
								{
									title: 'NTAK',
									field: 'settings',
									value: (v, row) => {
										if (row.ntak_cert !== null) {
											return row.ntak_cert.regnumber
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											var top = '<div>&nbsp;</div>'
											var bottom = ''
											if (row.settings !== null) {
												if (row.settings.ntak_enabled == 'on') {
													top = `<div class="text-success"><i class="fa fa-fw fa-university"></i> Éles</div>`
												} else if (row.settings.ntak_enabled == 'prepare') {
													top = `<div class="text-secondary"><i class="fa fa-fw fa-cog fa-spin"></i> Készül</div>`
												}
											}
											if (row.ntak_cert !== null) {
												bottom = `<div class="text-success" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-fw fa-certificate"></i> ${row.ntak_cert.regnumber} ${row.ntak_cert.sandbox ? '<strong>T</strong>' : ''}</div>`
											} else {
												bottom = `<div class="text-danger"><i class="fa fa-fw fa-certificate"></i> Nincs</div>`
											}
											return `${top}${bottom}`
										}
									},
									width: 100
								},
								/*
								{
									title: 'Pénztárgép',
									field: 'default_cashreg_ap',
									type: {
										render (value, row, options) {
											if (row.default_cashreg_ap === null) return ''
											return `<div class="list-db-id"><i class="fa fa-fw fa-cash-register text-primary"></i></div><strong>${row.default_cashreg_ap}</strong></span><br />
													${row.aee_last_inspection_d ? Anvil.moment(row.aee_last_inspection_d).add(1, 'year').format('YYYY.MM.DD') : ''}`

											// ${('msacsrv' in row.device_info) ? `<small class="text-dim">exe:${row.device_info.msacsrv.exe}; dll:${row.device_info.msacsrv.dll}</small>` : ''}`
										}
									},
									options: {
										cutoff: 40
									},
									width: 180
								},
								*/
								{
									title: 'Műveletek',
									field: 'id',
									value: (v, row) => {
										if (row.company_group_name !== null) {
											return row.company_group_name
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const notes_btn = (row.notes)
												?  `<div class="btn-group">
														<button class="btn btn-dark text-primary p-2" data-bs-toggle="dropdown"><i class="fa fa-fw fa-info-circle"></i></button>
														<div class="dropdown-menu p-2 text-muted" style="width:320px; box-shadow:0 2px 5px rgba(0, 0, 0, 0.1); white-space:normal;"><small>${row.notes.replaceAll('\n', '<br />')}</small></div>
													</div>`
												: `<button class="btn btn-dark text-dim disabled p-2"><i class="fa fa-fw fa-info-circle"></i></button>`

											const cloud_btn = (row.company_db_name !== null)
												? `<button class="btn btn-dark text-warning p-2" onclick="Anvil.page.sign_in_to_cloud('${row.company_db_name}')"><i class="fa fa-fw fa-sign-in-alt text-info"></i></button>`
												: `<button class="btn btn-dark text-dim disabled p-2"><i class="fa fa-fw fa-sign-in-alt"></i></button>`

											return `<div class="btn-group">${notes_btn}${cloud_btn}</div>`
										}
									},
									options: {
										class: 'text-center pb-0 overflow-visible'
									},
									width: 180
								},
								{
									title: 'Éves díj',
									field: 'licence_fee',
									type: {
										render (value, row, options) {
											return `<strong style="color:goldenrod;">${Anvil.numeral(value).format('0,0')}</strong>` + (row.partner_dividend > 0 ? `<br /><strong style="color:peru;">-${Anvil.numeral(row.partner_dividend).format('0,0')}</strong>` : '')
										}
									},
									options: {
										class: 'text-end'
									},
									width: 80
								},
								{
									title: 'Első indítás',
									field: 'first_start',
									type: {
										render (value, row, options) {
											const dt = Anvil.moment(value)
											return `${dt.format('YYYY.MM.DD. HH:mm')}<br /><small class="text-secondary">${dt.fromNow()}</small>`
										}
									},
									width: 140
								},
								{
									title: 'Utolsó indítás',
									field: 'recent_start',
									type: {
										render (value, row, options) {
											const dt = Anvil.moment(value)
											if (dt.isBefore(Anvil.moment().subtract(1, 'month'))) {
												return `<span class="text-danger">${dt.format('YYYY.MM.DD. HH:mm')}</span><br /><small class="text-secondary">${dt.fromNow()}</small>`
											} else if (dt.isBefore(Anvil.moment().subtract(1, 'week'))) {
												return `<span class="text-warning">${dt.format('YYYY.MM.DD. HH:mm')}</span><br /><small class="text-secondary">${dt.fromNow()}</small>`
											} else {
												return `${dt.format('YYYY.MM.DD. HH:mm')}<br /><small class="text-secondary">${dt.fromNow()}</small>`
											}
										}
									},
									width: 140
								}
							]
						},
						list: stores
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	searchModal () {
		Anvil.modal('/c_store/c_store/page_list_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []
		if (Anvil.page.search.company_group_id) {
			if (Anvil.page.search.company_group_id == -1) {
				filters.push(row => row.company_group_id === null)
			} else {
				filters.push(row => row.company_group_id == Anvil.page.search.company_group_id)
			}
		}

		const expression = $('#text-search').val()

		Anvil.models.components.Grid.find('#store_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('c_store/c_store/action_refresh')
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#store_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_store/c_store/modal_edit', sel[0])
		}
	},

	openSite (company_db_id, site_id) {
		Anvil.exec('c_order/site/modal_edit', company_db_id, site_id)
	},
})

$('#store_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
